module.exports = __webpack_public_path__ + "img/main_xxtd.434f4644.jpg";